import gql from "graphql-tag";

export default gql`
  query AssetsByGraphicSet($customerId: ID, $graphicSetId: ID) {
    assetsByGraphicSet(customerId: $customerId, graphicSetId: $graphicSetId) {
      items {
        id
        customerId
        codename
        sizePx {
          x
          y
        }
      }
      total
    }
  }
`;
